import { Button } from '@creanizer/ui'
import { Card } from '@creanizer/ui'
import { Badge } from '@creanizer/ui'
import { Copy, BookOpen, MessageCircle, Sparkles } from 'lucide-react'
import type { CommunityAnecdotes } from '@creanizer/types'

interface CommunityAnecdotesProps {
  anecdotes: CommunityAnecdotes
  onCopy: (text: string) => void
}

export function CommunityAnecdotes({ anecdotes, onCopy }: CommunityAnecdotesProps) {
  const formatAnecdotes = () => {
    const lines: string[] = []
    if (Array.isArray(anecdotes?.anecdotes)) {
      anecdotes.anecdotes.forEach((anecdote, index) => {
      lines.push(`■ 逸話${index + 1}：${anecdote.title}`)
      lines.push(`カテゴリー: ${anecdote.category}`)
      lines.push(`出典: ${anecdote.source}`)
      lines.push(`信憑性: ${anecdote.reliability}`)
      lines.push('')
      lines.push(anecdote.content)
      if (index < anecdotes.anecdotes.length - 1) {
        lines.push('')
        lines.push('─'.repeat(40))
        lines.push('')
      }
      })
    }
    return lines.join('\n')
  }

  const getCategoryIcon = (category: string) => {
    if (category.includes('英雄') || category.includes('冒険')) return <Sparkles className="h-4 w-4" />
    if (category.includes('怪談') || category.includes('恐怖')) return <MessageCircle className="h-4 w-4" />
    return <BookOpen className="h-4 w-4" />
  }

  const getReliabilityColor = (reliability: string) => {
    if (reliability.includes('高')) return 'text-green-600'
    if (reliability.includes('中')) return 'text-yellow-600'
    if (reliability.includes('低')) return 'text-red-600'
    return 'text-gray-600'
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">逸話</h3>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onCopy(formatAnecdotes())}
        >
          <Copy className="h-4 w-4 mr-1" />
          コピー
        </Button>
      </div>

      <div className="space-y-4">
        {Array.isArray(anecdotes?.anecdotes) && anecdotes.anecdotes.map((anecdote, index) => (
          <Card key={index} className="p-4">
            <div className="space-y-3">
              {/* ヘッダー */}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  {getCategoryIcon(anecdote.category)}
                  <h4 className="font-semibold text-base">{anecdote.title}</h4>
                </div>
                <Badge variant="secondary">{anecdote.category}</Badge>
              </div>

              {/* メタ情報 */}
              <div className="flex items-center gap-4 text-sm text-gray-600">
                <span>出典: {anecdote.source}</span>
                <span className={getReliabilityColor(anecdote.reliability)}>
                  信憑性: {anecdote.reliability}
                </span>
              </div>

              {/* 本文 */}
              <div className="border-l-2 border-gray-200 pl-4 py-2">
                <p className="text-sm leading-relaxed whitespace-pre-wrap">
                  {anecdote.content}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* 補足説明 */}
      <div className="text-xs text-gray-500 mt-4">
        <p>※ これらの逸話はこのコミュニティで語り継がれる物語です。内容の真偽は定かではありません。</p>
      </div>
    </div>
  )
}